"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingDeletion = void 0;
var react_i18next_1 = require("react-i18next");
var formatter_1 = require("@utils/formatter");
var react_1 = __importDefault(require("react"));
var date_fns_1 = require("date-fns");
var react_redux_1 = require("react-redux");
var dataStoringSlice_1 = require("@features/SettingsPage/state/dataStoringSlice");
var dataStoringDateFormat = function (date) {
    var pattern = "dd MMM yyyy HH:mm 'GMT'XXX";
    return (0, date_fns_1.format)(date, pattern);
};
function PendingDeletion() {
    var t = (0, react_i18next_1.useTranslation)().t;
    var pendingItems = (0, react_redux_1.useSelector)(dataStoringSlice_1.pendingItemsSelector);
    var oldestItem = (0, react_redux_1.useSelector)(dataStoringSlice_1.oldestItemSelector);
    var isPendingDeletionLoading = (0, react_redux_1.useSelector)(dataStoringSlice_1.isPendingDeletionLoadingSelector);
    return (react_1.default.createElement(react_1.default.Fragment, null, isPendingDeletionLoading ? (react_1.default.createElement("div", { className: "loadingContainer" },
        react_1.default.createElement("div", { className: "page-loading-icon" }))) : (react_1.default.createElement("p", { className: "main-text" }, pendingItems > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_i18next_1.Trans, { i18nKey: "settings:DATA_RETENTION_POLICY.AWAITING_DELETION_TEXT", values: {
                pendingItems: (0, formatter_1.thousandSeparator)(pendingItems),
                oldestItem: dataStoringDateFormat(new Date(oldestItem || 0)),
            }, components: { bold: react_1.default.createElement("strong", null) } }),
        react_1.default.createElement("br", null),
        react_1.default.createElement("br", null),
        t('settings:DATA_RETENTION_POLICY.AWAITING_DELETION_TEXT2'))) : (t('settings:DATA_RETENTION_POLICY.AWAITING_DELETION_TEXT_NO_ITEMS'))))));
}
exports.PendingDeletion = PendingDeletion;
